import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

i18n
    .use(initReactI18next)
    .init({
        resources: {
            en: {
                translation: {
                    common: {
                        cancel: 'Cancel',
                        confirm: 'Confirm',
                        success: 'Success',
                        error: 'Error',
                        yes: 'Yes',
                        no: 'No',
                        activated: 'Active',
                        inactive: 'Inactive',
                        saveButton: 'Save',
                        saveError: 'Failed to save',
                        saveSuccess: 'Saved successfully',
                        deleteSuccess: 'Deleted successfully',
                        deleteError: 'Failed to delete',
                        confirmTitle: 'Confirm',
                        confirmMessage: 'Are you sure you want to do this?',
                        loadingError: 'Failed to load',
                        updateSuccess: 'Updated successfully',
                        updateError: 'Failed to update',
                        loadErrorGeneric: 'Error loading data',
                        loadError: 'Error loading ',
                        loading: 'Loading...',
                        executeSuccess: 'Executed successfully',
                        executeError: 'Failed to execute',
                        networkError: 'Network response not ok. Status:',
                        inEnglish: 'in english',
                        inGerman: 'in german (optional)',
                        next: 'Next',
                        back: 'Back',
                        create: 'Create',
                        update: 'Update',
                        delete: 'Delete',
                        maintenance: 'Under Maintenance',
                        days: 'days',
                    },
                    threshold: {
                        title: 'Thresholds',
                        lowerBound: 'lower bound',
                        upperBound: 'upper bound',
                        color: 'color',
                        description: 'description',
                        failedToSave: 'Failed to save the threshold',
                        successSave: 'Saved',
                        addTitle: 'Add Threshold',
                        editTitle: 'Edit Threshold',
                        colorHint: 'named (red, blue, ...) or hex code: (#FFFFFF, ...) ',
                    },
                    log: {
                        logListTitle: 'Log Messages',
                        lastMessage: 'Last Log Message',
                        created: 'Date',
                        logLevel: 'Log Level',
                        message: 'Message',
                        showMessages: 'Logs',
                        systemMessages: 'System messages',
                        logListTitleShort: 'Logs',
                    },
                    fpf: {
                        address: 'Location',
                        noAddress: 'No Standort',
                        editFpF: 'Edit FPF',
                        createFpF: 'Create FPF',
                        hint: {
                            publicHint: 'Set the FPF to public or private',
                            sensorServiceIpHint: 'IP or URL of the FPF Backend',
                        },
                    },
                    header: {
                        loading: 'Loading...',
                        title: 'FARMINSIGHT',
                        noFpfAvailable: 'No FPF available',
                        organizations: 'Organizations',
                        myOrganizations: 'My Organizations',
                        loginToManage: 'Login to manage organization',
                        loginToManageFpf: 'Login to manage facility',
                        loginToSee: 'Login to see your organizations',
                        login: 'Login',
                        logout: 'Logout',
                        search: 'Search FPFs...',
                        email: 'Email',
                        name: 'Name',
                        enterName: 'Enter Name',
                        address: 'Address',
                        enterAddress: 'Enter Address',
                        location: 'Location',
                        enterLocation: 'Enter Location',
                        role: 'Role',
                        organization: 'Organization',
                        searchUserProfile: 'Search User Profile',
                        noProfilesFound: 'No profiles found',
                        addUser: 'Add User',
                        noUserSelected: 'No user selected',
                        addSelectedUser: 'Add Selected User',
                        usersAdded: ' users have been added',
                        addFpf: 'Add FPF',
                        addOrganization: 'Create Organization',
                        createOrganization: 'Create new Organization',
                        public: 'Public',
                        private: 'Private',
                        yesDelete: 'Yes, delete',
                        cancel: 'Cancel',
                        confirmDialog: 'This action cannot be undone. Are you sure you want to delete?',
                        members: 'Members',
                        isActive: 'Active',
                        actions: 'Actions',
                        addSensor: 'Add Sensor',
                        dateError: 'End date should be after start date',
                        addHarvest: 'Add a Harvest',
                        organizationUpdated: 'Organization updated successfully!',
                        userAdded: 'User added',
                        status: 'Status',
                        on: 'On',
                        off: 'Off',
                        auto: 'Auto',
                        table: {
                            name: 'Name',
                            planted: 'Planted on',
                            harvested: 'Harvested on',
                            notes: 'Notes',
                            date: 'Date',
                            amount: 'Amount (kg)',
                            details: 'Details for',
                        },
                        statusOverview: 'Status overview',
                        adminPage: 'Admin',
                        ping: 'Ping',
                        fpfs: 'FPFs',
                        url: 'URL',
                        addModel: 'Create model',
                        enterUrl: 'Enter URL',
                    },
                    sensor: {
                        addSensor: 'Add Sensor',
                        editSensor: 'Edit Sensor',
                        noConfig: 'No Configuration available',
                        model: 'Model',
                        connectionType: 'Connection Type',
                        parameter: 'Parameter',
                        parameter_hint: 'Please enter english and german',
                        unit: 'Unit',
                        tags: 'Notes',
                        searchHardware: 'Search Hardware',
                        hint: {
                            nameHint: 'Name of the sensor',
                            locationHint: 'Location of the sensor',
                            intervalSecondsHint: 'Interval of capturing data',
                        },
                        title: 'Sensors',
                        noSensorsFound: 'No Sensor found',
                        lastMeasurementAt: 'Last measurement at',
                        lastValue: 'Last value',
                        aggregatedValues: 'Aggregated values',
                        movingAverage: 'Smooth values',
                        measurementsLoadError: "Failed to fetch initial measurements.",
                        measurementsProcessError: "Failed to process incoming data.",
                        updatingSensor: 'Updating Sensor on your FPF',
                        creatingSensor: 'Saving Sensor on your FPF',
                    },
                    model: {
                        title: 'Models',
                        name: 'Model',
                        activeScenario: 'Active Scenario',
                        intervalSeconds: 'Interval in Seconds',
                        isActive: 'Active',
                        addModel: 'New Model',
                        editModel: 'Edit Model',
                        noModelsFound: 'No Models found',
                        updatingModel: 'Model was updated',
                        creatingModel: 'Model was created',
                        enterUrl: 'Enter URL',
                        urlStepDesc: 'Enter the base URL of the model',
                        configureModel: 'Configure model',
                        configStepDesc: 'Configure parameters for the model',
                        predictionViewTitle: 'Model Predictions',
                        modelType: 'Model Type',
                        modelTypeDescription: 'Type of resource this model manages',
                        modelTypeEnergy: 'Energy',
                        modelTypeWater: 'Water',
                        hint: {
                            locationHint: 'The URL of the model (e.g. http://<ip-adress>:<port>) The URL must provide sub endpoint /param and /farm-insight. For more details see the documentation.',
                            interval: 'The interval in which the model will do the calculation (default 1 day)',
                        },
                        overwriteParameters: 'Retrieve model parameters (This overwrites the current config!)',
                        errorFetchingModelParams: 'There was an error fetching the parameter of the models.',
                        assignActions: 'Assign actions',
                        assignActionsDescr: 'Map actions to controllable actions',
                    },
                    userManagement: {
                        userKicked: 'User was kicked from Organization.',
                        userPromoted: 'User was promoted.',
                        userDemoted: 'User was demoted.',
                        kick: 'Remove',
                        promote: 'Promote',
                        demote: 'Demote',
                    },
                    growingCycleForm: {
                        addCycle: 'Add Growing Cycle',
                        hint: {
                            plantTypeHint: 'Type of plant',
                            startDateHint: 'Start date of the growing cycle',
                            endDateHint: 'End date of the growing cycle',
                            notesHint: 'Notes on the growing cycle',
                        },
                        plantTypeLabel: 'Plant Type',
                        plantTypePlaceholder: 'Enter Plant Type',
                        startDateLabel: 'Start Date',
                        startDatePlaceholder: 'Select Start Date',
                        endDateLabel: 'End Date',
                        endDatePlaceholder: 'Select End Date',
                        notesLabel: 'Notes',
                        notesPlaceholder: 'Enter Notes',
                        noNotes: 'No notes available',
                        saveButton: 'Save',
                        successTitle: 'Success',
                        editSuccessMessage: 'Growing cycle updated successfully!',
                        createSuccessMessage: 'Growing cycle created successfully!',
                        errorTitle: 'Failed to save the growing cycle',
                        confirmDeletion: 'Are you sure you want to delete this growing cycle?',
                        totalHarvestAmount: 'Total Harvest',
                    },
                    sensorList: {
                        name: 'Name',
                        location: 'Location',
                        unit: 'Unit',
                        parameter: 'Parameter',
                        modelNr: 'Model',
                        intervalSeconds: 'Interval in Seconds',
                        isActive: 'Is Active?',
                        actions: 'Actions',
                        aggregate: 'Display Σ values?',
                    },
                    controllableActionList: {
                        forecastPending: 'No actions forecasted',
                        noActionFound: 'No Action found',
                        auto: 'Auto',
                        title: 'Controllable Actions',
                        name: 'Action name',
                        isActive: 'Is Active?',
                        actionClassId: 'Script Id',
                        actionScriptName: 'Script name',
                        actionScript: 'Action Script',
                        actionScriptPlaceholder: 'Search action scripts',
                        maximumDurationSeconds: 'Maximum duration in seconds',
                        hardware: 'FPF Hardware',
                        addAction: 'Add Controllable Action',
                        editAction: 'Edit Controllable Action',
                        triggerTitle: 'Trigger',
                        addControllable: 'Add controllable',
                        confirmTitle: 'Confirm Action',
                        confirmMessage: 'Are you sure you want to execute this action?',
                        confirmAutoMessage: 'Are you sure you want to enable the automatic control?',
                        autoDisabledNote: 'An active manual trigger is blocking other auto actions',
                        manualDisablesAutoWarning: 'Warning: Activating a manual trigger will disable auto triggers for this group. You must deactivate the manual trigger manually to re-enable the automated trigger.',
                        enableAutoMode: 'Activate Auto Trigger',
                        updating: 'Updating Controllable Action',
                        creating: 'Creating Controllable action..',
                        hint: {
                            nameHint: 'Name of the controllable action',
                            hardware: 'Optional: If this action blocks hardware on the FPF, set it here. Example: A robot arm which can only execute one action at a time.',
                            actionClass: 'Select from all available scripts at the FPF. The script will be executed by the triggers you define for this action.',
                            maximumDurationSeconds: 'The maximum duration of how long this action should take. It acts like a timeout for following actions for the same FPF hardware.',
                            actionClassId: 'The id of the script class',
                        },
                        trigger: {
                            addAction: 'Add Action Trigger',
                            editAction: 'Edit Action Trigger',
                            type: 'Type of trigger',
                            valueType: 'Value type',
                            value: 'Value',
                            status: 'Status',
                            enterType: 'Enter type',
                            actionValueType: 'Action value type',
                            enterActionValueType: 'Enter action value type',
                            actionValue: 'Action value',
                            enterActionValue: 'Enter action value',
                            triggerLogic: 'Advanced trigger logic',
                            enterTriggerLogic: 'Enter Trigger Logic',
                            description: 'Description',
                            enterDescription: 'Enter description',
                            active: 'Executable',
                            running: 'Active',
                            inactive: 'Execute',
                            is_active: 'Active',
                            not_active: 'Inactive',
                            lastTriggered: 'Last triggered',
                            hint: {
                                typeHint: 'Select appropriate trigger type.',
                                actionValueTypeHint: 'Set the correct type of the action value. For example the value "On" is string.',
                                actionValueHint: 'Check on your desired action script for allowed values.',
                                triggerLogicHint: 'Advanced trigger logic for the trigger in JSON format.',
                                descriptionHint: 'Describe the trigger in more detail',
                            }
                        },
                        queue: {
                            noEntriesFound: 'No Entry found',
                            title: 'Action queue',
                            createdAt: 'Queued at',
                            startedAt: 'Started at',
                            endedAt: 'Finished at',
                        }
                    },
                    hardware: {
                        title: 'Hardware',
                        notFound: 'No Hardware found',
                        name: 'Name',
                        add: 'Add Hardware',
                        edit: 'Edit Hardware',
                        canNotDeleteHint: 'Hardware can not be deleted because it is still used by a Controllable Action',
                        confirmDeletion: 'Are you sure you want to delete this hardware?',
                    },
                    button: {
                        loginToManage: 'Login to manage organization',
                        create: 'Create',
                        add: 'Add',
                        update: 'Save changes'
                    },
                    label: {
                        organizationName: 'Organization Name',
                        setPublic: 'Set Public',
                        setCameraCarousel: 'Image or Livestream'
                    },
                    placeholder: {
                        enterOrganizationName: 'Enter organization name'
                    },
                    error: {
                        organizationNameTaken: 'Organization Name already taken',
                        fireFoxError: "Your browser is not fully supported. Some features, such as graphs and cameras, may not work as expected.\nPlease use a different browser for the best experience."

                    },
                    userprofile: {
                        changePassword: 'Change Password',
                        notifications: {
                            success: {
                                title: 'Successfully updated',
                                message: 'Updated the Profile name successfully!',
                            },
                            error: {
                                title: 'Unable to update profile name',
                            }
                        },
                        enterName: 'Enter your display name',
                        saveChanges: 'Save Changes',
                    },
                    camera: {
                        active: 'Active',
                        inactive: 'Inactive',
                        cameras: 'Cameras',
                        hint: {
                            nameHint: 'Name of the camera',
                            locationHint: 'Location of the camera',
                            modelNrHint: 'Model number of the camera',
                            intervalSecondsHint: 'Interval of capturing images',
                            resolutionHint: 'Resolution of the camera',
                            livestreamUrlHint: 'URL for the livestream',
                            snapshotUrlHint: 'URL for the snapshot',
                        },
                        cameraList: 'Camera List',
                        noCamerasFound: 'No Camera found',
                        location: 'Location',
                        enterLocation: 'Enter Location',
                        modelNr: 'Model Nr.',
                        enterModelNr: 'Enter Model Nr.',
                        intervalSeconds: 'Interval in Seconds',
                        enterIntervalSeconds: 'Enter Interval in Seconds',
                        resolution: 'Resolution',
                        enterResolution: 'Enter Resolution',
                        livestreamUrl: 'Livestream URL',
                        enterLivestreamUrl: 'Enter Livestream URL',
                        snapshotUrl: 'Snapshot URL',
                        enterSnapshotUrl: 'Enter Snapshot URL',
                        addCamera: 'Add Camera',
                        editCamera: 'Edit Camera',
                        createCamera: 'Create Camera',
                        updating: 'Updating camera',
                    },
                    harvestEntityForm: {
                        hint: {
                            dateDescription: 'Date of the harvest',
                            amountDescription: 'Amount of the harvest',
                            notesDescription: 'Notes on the harvest',
                        },
                        addHarvest: 'Add Harvest entry',
                        editHarvest: 'Edit Harvest entry',
                        dateLabel: 'Date',
                        datePlaceholder: 'Select Date',
                        amountLabel: 'Amount (kg)',
                        amountPlaceholder: 'Enter Amount',
                        amountDescription: "Use '.' for decimals, not ','",
                        notesLabel: 'Notes',
                        notesPlaceholder: 'Enter Notes',
                        saveButton: 'Save',
                        details: 'Harvest Entry Details',
                        deleteTitle: 'Are you sure you want to delete this harvest entry?',
                    },
                    timeRangeSelector: {
                        from: 'From',
                        datePlaceholder: "Select Date",
                        to: 'To',
                        apply: 'Apply',
                        label24H: 'Last 24h',
                        labelWeek: 'Last Week',
                        labelMonth: 'Last Month',
                        labelYear: 'Last Year',
                        labelCustom: 'Custom Date'
                    },
                    weatherForecast: {
                        title: 'Weather Forecast',
                        location: 'Location',
                        forecastDate: 'Forecast Date',
                        fetchDate: 'Fetch Date',
                        temperatureMinC: 'Temperature Min',
                        temperatureMaxC: 'Temperature Max',
                        rainMM: 'Rain',
                        sunshineDurationSeconds: 'Sunshine Duration',
                        windSpeedMax: 'Wind Speed Max',
                        sunrise: 'Sunrise',
                        sunset: 'Sunset',
                        precipitationMM: 'Precipitation',
                        precipitationProbability: 'Precipitation Probability',
                        text: {
                            temperature: 'Temperature',
                            precipitation: 'Precipitation',
                            probability: 'Probability of',
                            today: 'Today',
                            tomorrow: 'Tomorrow',
                            afterTomorrow: 'After Tomorrow',
                        },
                        weatherCode: {
                            weatherCode: 'Weather Code',
                            tooltip: 'Shows the worst-case weather expected for the day',
                            clear: 'Clear',
                            mainlyClear: 'Mainly Clear',
                            partlyCloudy: 'Partly Cloudy',
                            overcast: 'Overcast',
                            fog: 'Fog',
                            fogWithRime: 'Fog with Rime',
                            drizzleLight: 'Light Drizzle',
                            drizzleModerate: 'Drizzle Moderate',
                            drizzleDense: 'Drizzle Dense',
                            freezingDrizzleLight: 'Freezing Drizzle Light',
                            freezingDrizzleDense: 'Freezing Drizzle Dense',
                            rainLight: 'Light Rain',
                            rainModerate: 'Moderate Rain',
                            rainHeavy: 'Heavy Rain',
                            freezingRainLight: 'Light Freezing Rain',
                            freezingRainHeavy: 'Heavy Freezing Rain',
                            snowFallLight: 'LightSnow Fall',
                            snowFallModerate: 'Moderate Snow Fall',
                            snowFallHeavy: 'Heavy Snow Fall',
                            snowGrains: 'Snow Grains',
                            rainShowersLight: 'Light Rain Showers',
                            rainShowersModerate: 'Moderate Rain Showers',
                            rainShowersHeavy: 'Heavy Rain Showers',
                            snowShowersLight: 'Light Snow Showers',
                            snowShowersHeavy: 'HeavySnow Showers',
                            thunderstormWithLightHail: 'Thunderstorm with Light Hail',
                            thunderstormWithModerateHail: 'Thunderstorm with moderate hail',
                            thunderstormWithHail: 'Thunderstorm with Hail',
                            thunderstormWithHeavyHail: 'Thunderstorm with Heavy Hail',
                        },
                    },
                    location: {
                        noLocation: 'No Location',
                        name: 'Name',
                        city: 'City',
                        street: 'Street',
                        houseNumber: 'House Number',
                        latitude: 'Latitude',
                        longitude: 'Longitude',
                        gatherForecasts: 'Gather Forecasts',
                        gatherForecastsNotActive: 'No Forecasts',
                        gatherForecastsActive: 'Gathers Forecast',
                        buttons: {
                            showForm: 'Create new Location',
                            hideForm: 'Hide ',
                            addLocation: 'Add Location',
                            editLocation: 'Edit Location',
                            createLocation: 'Create Location',

                        },
                        text: {
                            location: 'Location',
                            locations: 'Locations',
                            addLocation: 'Add Location',
                            isActive: 'Gather Forecasts',
                            isNotActive: 'No Forecasts',
                        },
                        notifications: {
                            loading: {
                                title: 'Loading',
                                message: 'Loading locations...',
                            },
                            success: {
                                title: 'Successfully updated',
                                message: 'Location updated successfully!',
                            },
                            error: {
                                title: 'Unable to update location',
                                message: 'Unable to send location',
                            }
                        },
                    },
                    notification: {
                        title: 'Matrix Notification Rooms',
                        confirmDeletion: 'Confirm Deletion',
                        add: 'Add Notification Room',
                        roomId: 'Room ID',
                        name: 'Name',
                        notFound: 'No notification rooms found.',
                        roomIdPlaceholder: 'Enter Matrix Room ID (e.g., !...:matrix.org)',
                        namePlaceholder: 'Enter a display name',
                    },
                    overview: {
                        green: 'All good',
                        yellow: 'One missed value',
                        red: 'Multiple missed values',
                        grey: 'Inactive',
                        other: 'Unknown',
                        lastPing: 'Last ping',
                        pingResult: 'Ping result',
                    },
                    admin: {
                        resetPassword: 'Reset Password',
                        copyPasswordHint: 'Copy the new password and send it to the user',
                        copy: 'Copy',
                        copied: 'Copied',
                        activeUsers: 'Active Users',
                        inactiveUsers: 'Inactive Users',
                        deactivate: 'Deactivate',
                        reactivate: 'Reactivate',
                    },
                    energy: {
                        dashboardTitle: 'Energy Management',
                        batteryLevel: 'Battery Level',
                        powerBalance: 'Power Balance',
                        production: 'Production',
                        consumption: 'Consumption',
                        netPower: 'Net Power',
                        gridStatus: 'Grid Status',
                        gridConnected: 'Connected',
                        gridDisconnected: 'Disconnected',
                        gridConnectAt: 'Connect at',
                        currentAction: 'Current Action',
                        sources: 'Energy Sources',
                        consumers: 'Energy Consumers',
                        noSourcesFound: 'No energy sources found',
                        noConsumersFound: 'No energy consumers found',
                        addSource: 'Add Energy Source',
                        editSource: 'Edit Energy Source',
                        addConsumer: 'Add Energy Consumer',
                        editConsumer: 'Edit Energy Consumer',
                        sourceName: 'Name',
                        sourceNamePlaceholder: 'Enter source name',
                        sourceType: 'Source Type',
                        sourceSolar: 'Solar',
                        sourceWind: 'Wind',
                        sourceGrid: 'Grid',
                        sourceBattery: 'Battery',
                        sourceGenerator: 'Generator',
                        maxOutputWatts: 'Max Output (W)',
                        currentOutputWatts: 'Current Output (W)',
                        currentOutput: 'Current Output',
                        maxOutput: 'Max Output',
                        weatherDependent: 'Weather Dependent',
                        weatherDependentDescription: 'Output depends on weather conditions',
                        consumerName: 'Name',
                        consumerNamePlaceholder: 'Enter consumer name',
                        consumptionWatts: 'Consumption (W)',
                        priority: 'Priority',
                        priorityDescription: '1 = Critical, 10 = Optional',
                        priorityCritical: 'Critical',
                        priorityMedium: 'Medium',
                        priorityLow: 'Low',
                        consumerShutdownThreshold: 'Auto-Shutdown Threshold',
                        consumerShutdownThresholdDescription: 'Battery level at which this consumer will be automatically shut down',
                        shutdownNever: 'Never',
                        aiShutdown: 'AI Shutdown',
                        aiControlled: 'AI Controlled',
                        shutdownUseGlobal: 'Uses global threshold settings (no individual shutdown)',
                        shutdownAtPercent: 'Will shutdown when battery falls below {{percent}}%',
                        dependencies: 'Dependencies',
                        dependenciesDescription: 'Consumers that must be active for this consumer',
                        selectDependencies: 'Select dependencies',
                        noDependencies: 'None',
                        isActive: 'Active',
                        nameRequired: 'Name is required',
                        consumerCreated: 'Consumer created successfully',
                        consumerUpdated: 'Consumer updated successfully',
                        consumerDeleted: 'Consumer deleted successfully',
                        sourceCreated: 'Source created successfully',
                        sourceUpdated: 'Source updated successfully',
                        sourceDeleted: 'Source deleted successfully',
                        settings: 'Energy Settings',
                        manualBatteryLevel: 'Battery Level (Wh)',
                        manualBatteryLevelDescription: 'Set the current battery level manually for testing',
                        updateBatteryLevel: 'Update Battery Level',
                        thresholdConfiguration: 'Threshold Configuration',
                        gridConnectThreshold: 'Grid Connect Threshold',
                        gridConnectThresholdDescription: 'Connect to grid when battery falls below this level (before shutdown)',
                        shutdownThreshold: 'Critical Shutdown Threshold',
                        shutdownThresholdDescription: 'CRITICAL: Connect grid AND shutdown non-critical consumers at this level (near BMS cutoff)',
                        warningThreshold: 'Warning Threshold',
                        warningThresholdDescription: 'Show warning status below this level',
                        gridDisconnectThreshold: 'Grid Disconnect Threshold',
                        gridDisconnectThresholdDescription: 'Disconnect from grid when battery exceeds this level (with power surplus)',
                        thresholdNote: 'Note: Shutdown threshold should be lower than Grid Connect threshold. At 10% most BMS systems cut off.',
                        configurationTitle: 'Energy Configuration',
                        configurationSubtitle: 'Configure thresholds and battery settings for this FPF',
                        unsavedChanges: 'Unsaved Changes',
                        batteryCapacity: 'Battery Capacity',
                        maxBatteryCapacity: 'Maximum Battery Capacity',
                        maxBatteryCapacityDescription: 'Total battery storage capacity in Watt-hours',
                        thresholdSettings: 'Threshold Settings',
                        thresholdPreview: 'Battery Zone Preview',
                        zoneShutdown: 'Critical',
                        zoneGridConnect: 'Grid Connect',
                        zoneWarning: 'Warning',
                        zoneNormal: 'Normal',
                        zoneOptimal: 'Optimal',
                        resetChanges: 'Reset',
                        saveConfiguration: 'Save Configuration',
                        configSaved: 'Energy configuration saved successfully',
                        linkedSensor: 'Linked Sensor',
                        linkedSensorDescription: 'Link to a sensor for live power consumption measurement (e.g., smart plug power reading)',
                        linkedSensorSourceDescription: 'Link to a sensor for live power output measurement (e.g., solar inverter)',
                        selectSensor: 'Select a sensor...',
                        sensorLinkedInfo: 'Live consumption data will be used from this sensor instead of the static value above.',
                        sensorLinkedSourceInfo: 'Live output data will be used from this sensor instead of the static value above.',
                        linkedAction: 'Linked Controllable Action',
                        linkedActionDescription: 'Link to a controllable action for automatic on/off control (e.g., smart plug)',
                        linkedActionSourceDescription: 'Link to a controllable action for source control (e.g., grid connection switch)',
                        selectAction: 'Select an action...',
                        actionLinkedInfo: 'This consumer can be automatically controlled by the energy management system.',
                        actionLinkedSourceInfo: 'This source can be automatically controlled by the energy management system.',
                        consumptionLiveNote: 'If a sensor is linked, this value is used as fallback only.',
                        consumptionLiveMeasured: 'This value is measured live by the linked sensor.',
                        consumptionManualDescription: 'Enter the expected power consumption manually.',
                        measuredBySensor: 'Measured by sensor',
                        outputLiveNote: 'If a sensor is linked, this value is used as fallback only.',
                        outputLiveMeasured: 'This value is measured live by the linked sensor.',
                        outputManualDescription: 'Enter the current power output manually.',
                        batteryCapacitySource: 'Battery Capacity (Wh)',
                        batteryCapacitySourceDescription: 'Maximum energy capacity of the battery in Watt-hours (Wh).',
                        action: {
                            normal: 'Normal Operation',
                            connect_grid: 'Connect to Grid',
                            disconnect_grid: 'Disconnect from Grid',
                            shutdown_non_critical: 'Shutdown Non-Critical',
                            emergency_shutdown: 'Emergency Shutdown'
                        },
                        forecastGraph: 'Energy Forecast',
                        historicalConsumption: 'Historical Consumption',
                        forecastConsumption: 'Forecast Consumption',
                        forecastExpected: 'Expected Generation',
                        forecastBestCase: 'Best Case',
                        forecastWorstCase: 'Worst Case',
                        generation: 'Generation',
                        noForecastData: 'No Data Available',
                        noForecastDataHint: 'No energy data is available yet. Add energy consumers and sources to start tracking, or configure an energy model for predictions.',
                        noEnergyModel: 'No Energy Model Configured',
                        noEnergyModelHint: 'To see energy generation forecasts, add a model with type "Energy" in the Models section of your FPF settings.',
                        forecastGraphInfo: 'This graph shows historical consumption and predicted energy generation based on your configured energy models.',
                        liveFromSensor: 'Live',
                        lastUpdated: 'Last updated',
                        noBatterySource: 'No battery source configured',
                        batterySourceHint: 'Add an Energy Source with type "Battery" and link a sensor to get live battery levels.',
                        batterySoC: 'Battery Capacity',
                        batterySoCExpected: 'Expected',
                        batterySoCWorstCase: 'Worst Case',
                        batterySoCBestCase: 'Best Case',
                        days1: '1 Day',
                        days3: '3 Days',
                        days7: '7 Days',
                        days14: '14 Days',
                        currentLevel: 'Current Level',
                        disabled: 'Disabled',
                        forecastShutdown: 'AI Forecast Shutdown',
                        forecastShutdownDescription: 'Proactively shutdown this consumer when the AI model predicts the battery will reach a critical level.',
                        forecastThresholdLabel: 'Predicted Battery Threshold',
                        forecastThresholdHint: 'Shutdown when AI predicts battery will reach {{percent}}%',
                        forecastDisabled: 'AI forecast-based shutdown is disabled',
                        forecastBufferDays: 'Buffer Days',
                        forecastBufferDaysHint: 'Execute shutdown this many days BEFORE the predicted threshold is reached',
                        forecastShutdownExplanation: 'When the AI model predicts that the battery will reach {{threshold}}%, this consumer will be shut down {{buffer}} days in advance.',
                        forecastNeedsAction: 'To enable AI-based shutdown, you must first link a Controllable Action above.',
                        energyProduction: 'Energy Production',
                        energyStorage: 'Energy Storage',
                        noProductionSources: 'No energy production sources configured',
                        noStorageSources: 'No energy storage sources configured',
                        storageName: 'Storage Name',
                        currentCapacity: 'Current Capacity',
                        maxCapacity: 'Max Capacity',
                        chargeLevel: 'Charge Level'
                    },
                    resources: {
                        managementTitle: 'Resource Management',
                        managementDesc: 'Configure resource monitoring and management',
                        waterResourceTitle: 'Water Resource Management',
                        waterResourceDesc: 'Enable water and soil monitoring features',
                        waterSensorId: 'Water Sensor ID',
                        waterSensorIdPlaceholder: 'e.g. water-sensor-01',
                        soilSensorId: 'Soil Sensor ID',
                        soilSensorIdPlaceholder: 'e.g. soil-moisture-01',
                        tankCapacity: 'Tank Capacity',
                    },
                    water: {
                        dashboardTitle: 'Water Management',
                        tankLevel: 'Water Tank Level',
                        currentLevel: 'Current Level',
                        systemStatus: 'System Status',
                        dailyUsage: 'Average Usage',
                        pumpStatus: 'Pump Status',
                        modelsTitle: 'Water Consumption Forecast',
                        waterLevelChartTitle: 'Water Level (Last 7 Days)',
                        fieldMoisture: 'Field Moisture Values',
                        status: 'Status',
                        moisture: 'Moisture',
                        field: 'Field',
                        dry: 'Dry',
                        moderate: 'Moderate',
                        moist: 'Moist',
                        wet: 'Wet',
                        aiInsight: 'AI Insight',
                        rainProbability: 'Rain probability today is',
                        statusCritical: 'Critical',
                        statusNormal: 'Normal',
                        statusLow: 'Water level low',
                        statusGood: 'Everything looks good',
                        pumpActive: 'This week active',
                        pumpInactive: 'This week inactive',
                        frozen: 'FROZEN',
                        noData: 'No data available',
                    }
                },
            },
            de: {
                translation: {
                    common: {
                        cancel: 'Abbrechen',
                        confirm: 'Bestätigen',
                        success: 'Erfolg',
                        error: 'Fehler',
                        yes: 'Ja',
                        no: 'Nein',
                        activated: 'Aktiviert',
                        inactive: 'Inaktiv',
                        saveButton: 'Speichern',
                        saveError: 'Fehler beim Speichern',
                        saveSuccess: 'Erfolgreich gespeichert',
                        deleteSuccess: 'Erfolgreich gelöscht',
                        deleteError: 'Fehler beim Löschen',
                        confirmTitle: 'Bestätige Ausführung',
                        confirmMessage: 'Sind Sie sicher, dass Sie das tun wollen?',
                        loadingError: 'Fehler beim Laden',
                        updateSuccess: 'Erfolgreich geändert',
                        updateError: 'Fehler beim ändern',
                        loadErrorGeneric: 'Fehler beim laden der Daten',
                        loadError: 'Fehler beim laden von ',
                        loading: 'Laden...',
                        executeSuccess: 'Erfolgreich ausgeführt',
                        executeError: 'Fehler beim Ausführen',
                        networkError: 'Netzwerk Antwort fehlerhaft. Status:',
                        inEnglish: 'auf Englisch',
                        inGerman: 'auf Deutsch (optional)',
                        next: 'Weiter',
                        back: 'Zurück',
                        create: 'Erstellen',
                        update: 'Aktualisieren',
                        delete: 'Löschen',
                        maintenance: 'Wartungsmodus',
                        days: 'Tage',
                    },
                    threshold: {
                        title: 'Grenzwerte',
                        lowerBound: 'untere Grenze',
                        upperBound: 'obere Grenze',
                        color: 'Farbe',
                        description: 'Beschreibung',
                        failedToSave: 'Fehler beim Speichern des Grenzwertes',
                        addTitle: 'Grenzwert hinzufügen',
                        editTitle: 'Grenzwert bearbeiten',
                        colorHint: 'Name (rot, blau, ...) oder Hexcode: (#FFFFFF, ...)',
                    },
                    log: {
                        logListTitle: 'Protokoll Nachrichten',
                        lastMessage: 'Letzte Protokoll Nachricht',
                        created: 'Datum',
                        logLevel: 'Protokollierungsstufe',
                        message: 'Nachricht',
                        showMessages: 'Protokoll Nachrichten',
                        systemMessages: 'System Protokoll Nachrichten',
                        logListTitleShort: 'Protokolle',
                    },
                    fpf: {
                        address: 'Standort',
                        noAddress: 'Kein Adresse',
                        editFpF: 'FPF bearbeiten',
                        createFpF: 'FPF erstellen',
                        hint: {
                            publicHint: 'FPF öffentlich oder privat einstellen.',
                            sensorServiceIpHint: 'IP oder URL des FPF-Backends',
                        },
                    },
                    header: {
                        loading: 'Laden...',
                        title: 'FARMINSIGHT',
                        noFpfAvailable: 'Kein FPF verfügbar',
                        organizations: 'Organisationen',
                        myOrganizations: 'Meine Organisationen',
                        loginToManage: 'Anmelden, um Organisation zu verwalten',
                        loginToSee: 'Anmelden, um Ihre Organisationen zu sehen',
                        login: 'Anmelden',
                        logout: 'Abmelden',
                        search: 'FPFs durchsuchen...',
                        email: 'E-Mail-Adresse',
                        name: 'Name',
                        enterName: 'Name eingeben',
                        address: 'Adresse',
                        enterAddress: 'Adresse eingeben',
                        location: 'Standort',
                        enterLocation: 'Standort eingeben',
                        role: 'Rolle',
                        organization: 'Organisation',
                        searchUserProfile: 'Nutzerprofil suchen',
                        addUser: 'Benutzer hinzufügen',
                        noProfilesFound: 'Keine Profile gefunden',
                        noUserSelected: 'Kein Benutzer ausgewählt',
                        addSelectedUser: 'Ausgewählten Benutzer hinzufügen',
                        usersAdded: ' Benutzer wurden hinzugefügt',
                        addFpf: 'FPF hinzufügen',
                        addOrganization: 'Organisation erstellen',
                        createOrganization: 'Neue Organisation erstellen',
                        public: 'Öffentlich',
                        private: 'Privat',
                        yesDelete: 'Ja, löschen',
                        cancel: 'Abbrechen',
                        confirmDialog: 'Diese Aktion kann nicht rückgängig gemacht werden. Sind Sie sicher, dass es gelöscht werden soll?',
                        members: 'Mitglieder',
                        isActive: 'Aktiv',
                        actions: 'Aktionen',
                        addSensor: 'Sensor hinzufügen',
                        dateError: 'Enddatum sollte nach dem Startdatum liegen',
                        organizationUpdated: 'Organisation erfolgreich aktualisiert!',
                        userAdded: 'Benutzer hinzugefügt',
                        status: 'Status',
                        on: 'An',
                        off: 'Aus',
                        auto: 'Auto',
                        table: {
                            name: 'Name',
                            planted: 'Gepflanzt am',
                            harvested: 'Geerntet am',
                            notes: 'Bemerkungen',
                            date: 'Datum',
                            amount: 'Menge (kg)',
                            details: 'Details für',
                        },
                        statusOverview: 'Status Übersicht',
                        adminPage: 'Admin',
                        ping: 'Ping',
                        fpfs: 'FPFs',
                        url: 'URL',
                        addModel: 'Modell erstellen',
                        enterUrl: 'URL eingeben',
                    },
                    sensor: {
                        addSensor: 'Sensor hinzufügen',
                        editSensor: 'Sensor bearbeiten',
                        noConfig: 'Keine Konfiguration verfügbar',
                        model: 'Modell',
                        connectionType: 'Verbindungstyp',
                        parameter: 'Kennwert',
                        parameter_hint: 'Bitte in Englisch und Deutsch eingeben',
                        unit: 'Einheit',
                        tags: 'Notizen',
                        searchHardware: 'Hardware suchen',
                        hint: {
                            nameHint: 'Name des Sensors',
                            locationHint: 'Standort des Sensors',
                            intervalSecondsHint: 'Intervall zum Erfassen von Daten',
                        },
                        title: 'Sensoren',
                        noSensorsFound: 'Kein Sensor gefunden',
                        lastMeasurementAt: "Letzer Wert empfangen",
                        lastValue: 'Letzter Wert',
                        aggregatedValues: 'Zusammengefasste Werte',
                        movingAverage: 'Mittelwert glätten',
                        measurementsLoadError: "Fehler beim Laden der initialen Werte.",
                        measurementsProcessError: "Fehler beim Verarbeiten der erhaltenen Werte.",
                        updatingSensor: 'Sensor wird in Ihrer FPF aktualisiert',
                        creatingSensor: 'Sensor wird in Ihrer FPF erzeugt',
                    },
                    model: {
                        title: 'Modelle',
                        name: 'Modell',
                        activeScenario: 'Aktives Szenario',
                        intervalSeconds: 'Intervall in Sekunden',
                        isActive: 'Aktiv',
                        addModel: 'Neues Modell',
                        editModel: 'Modell bearbeiten',
                        noModelsFound: 'Kein Modell gefunden',
                        updatingModel: 'Modell wurde aktualisiert',
                        creatingModel: 'Modell wurde erstellt',
                        enterUrl: 'URL eingeben',
                        urlStepDesc: 'Gebe die URL des Modells ein',
                        configureModel: 'Konfiguriere das Modell',
                        configStepDesc: 'Konfiguriere die Parameter des Modells',
                        predictionViewTitle: 'Modell Vorhersagen',
                        modelType: 'Modelltyp',
                        modelTypeDescription: 'Art der Ressource, die dieses Modell verwaltet',
                        modelTypeEnergy: 'Energie',
                        modelTypeWater: 'Wasser',
                        hint: {
                            locationHint: 'Die URL des Modells (z.B. http://<ip-adress>:<port>). Die URL muss die Endpunkte /param und /farm-insight bereitstellen. Für weitere Details siehe Dokumentation.',
                            interval: 'Das Intervall, in dem das Modell die Berechnung durchführt (Standard 1 Tag)',
                        },
                        errorFetchingModelParams: 'Es gab einen Fehler die Parameter vom Model abzurufen.',
                        assignActions: 'Verknüpfe Aktionen',
                        assignActionsDescr: 'Verknüpfe Aktionen vom Model zu kontrollierbaren Aktionen',
                        overwriteParameters: 'Modellparameter abrufen (Überschreibt die aktuelle Konfiguration!)'
                    },
                    userManagement: {
                        userKicked: 'Benutzer wurde aus der Organisation entfernt.',
                        userPromoted: 'Benutzer wurde befördert.',
                        userDemoted: 'Benutzer wurde zurückgestuft.',
                        kick: 'Entfernen',
                        promote: 'Befördern',
                        demote: 'Zurückstufen',
                    },
                    growingCycleForm: {
                        addCycle: 'Wachstumszyklus hinzufügen',
                        hint: {
                            plantTypeHint: 'Pflanzentyp',
                            startDateHint: 'Startdatum des Wachstumszyklus',
                            endDateHint: 'Enddatum des Wachstumszyklus',
                            notesHint: 'Notizen zum Wachstumszyklus',
                        },
                        plantTypeLabel: 'Pflanzentyp',
                        plantTypePlaceholder: 'Pflanzentyp eingeben',
                        startDateLabel: 'Startdatum',
                        startDatePlaceholder: 'Startdatum auswählen',
                        endDateLabel: 'Enddatum',
                        endDatePlaceholder: 'Enddatum auswählen',
                        notesLabel: 'Notizen',
                        notesPlaceholder: 'Notizen eingeben',
                        noNotes: 'Keine Notizen vorhanden',
                        saveButton: 'Speichern',
                        successTitle: 'Erfolg',
                        editSuccessMessage: 'Wachstumszyklus erfolgreich aktualisiert!',
                        createSuccessMessage: 'Wachstumszyklus erfolgreich erstellt!',
                        errorTitle: 'Speichern des Wachstumszyklus fehlgeschlagen',
                        confirmDeletion: 'Wollen Sie den Wachstumszyklus wirklich löschen?',
                        totalHarvestAmount: 'Gesamternte',
                    },
                    sensorList: {
                        name: 'Name',
                        location: 'Standort',
                        unit: 'Einheit',
                        parameter: 'Kennwert',
                        modelNr: 'Modell',
                        intervalSeconds: 'Intervall in Sekunden',
                        isActive: 'Ist aktiv?',
                        actions: 'Aktionen',
                        aggregate: 'Σ Werte ausgeben?'
                    },
                    controllableActionList: {
                        forecastPending: 'Keine Aktionen geplant',
                        noActionFound: 'Keine Aktionen gefunden',
                        auto: "Auto",
                        title: "Steuerbare Aktionen",
                        name: "Aktionsname",
                        isActive: "Ist aktiv?",
                        actionClassId: "Skript-ID",
                        actionScriptName: "Skriptname",
                        actionScript: 'Skript',
                        actionScriptPlaceholder: 'Skripts durchsuchen',
                        maximumDurationSeconds: "Maximale Dauer in Sekunden",
                        hardware: "FPF-Hardware",
                        addAction: "Steuerbare Aktion hinzufügen",
                        editAction: "Steuerbare Aktion bearbeiten",
                        triggerTitle: "Auslöser",
                        addControllable: "Steuerbares Element hinzufügen",
                        confirmTitle: 'Bestätige Ausführung',
                        confirmMessage: 'Sind Sie sicher, dass Sie eine Aktion ausführen wollen?',
                        confirmAutoMessage: 'Sind Sie sicher, dass Sie die automatische Steuerung aktivieren wollen?',
                        autoDisabledNote: 'Ein aktiver manueller Trigger blockiert andere Auto-Aktionen',
                        manualDisablesAutoWarning: 'Warnung: Das Aktivieren eines manuellen Triggers deaktiviert die automatischen Trigger für diese Gruppe. Du musst den manuellen Trigger manuell deaktivieren, um den automatischen Trigger wieder zu aktivieren.',
                        enableAutoMode: 'Aktiviere Auto Trigger',
                        updating: 'Steuerbare Aktion wird geändert',
                        creating: 'Steuerbare Aktion wird erstellt',
                        hint: {
                            nameHint: "Name der steuerbaren Aktion",
                            hardware: "Optional: Wenn diese Aktion Hardware auf dem FPF blockiert, hier festlegen. Beispiel: Ein Roboterarm, der nur eine Aktion gleichzeitig ausführen kann.",
                            actionClass: "Aus allen verfügbaren Skripten auf dem FPF auswählen. Das Skript wird durch die von Ihnen definierten Auslöser für diese Aktion ausgeführt.",
                            maximumDurationSeconds: "Die maximale Dauer, wie lange diese Aktion dauern sollte. Sie fungiert als Timeout für nachfolgende Aktionen für dieselbe FPF-Hardware.",
                            actionClassId: "Die ID der Skriptklasse"
                        },
                        trigger: {
                            addAction: "Aktionsauslöser hinzufügen",
                            editAction: "Aktionsauslöser bearbeiten",
                            type: "Auslöser-Typ",
                            valueType: "Werttyp",
                            value: "Wert",
                            status: "Status",
                            enterType: "Typ eingeben",
                            actionValueType: "Aktionswerttyp",
                            enterActionValueType: "Aktionswerttyp eingeben",
                            actionValue: "Aktionswert",
                            enterActionValue: "Aktionswert eingeben",
                            triggerLogic: "Erweiterte Auslöserlogik",
                            enterTriggerLogic: "Auslöserlogik eingeben",
                            description: "Beschreibung",
                            enterDescription: "Beschreibung eingeben",
                            active: 'Ausführbar',
                            running: 'Aktiv',
                            inactive: 'Ausführen',
                            is_active: 'Aktiv',
                            not_active: 'Inaktiv',
                            lastTriggered: 'Zuletzt ausgelöst',
                            hint: {
                                typeHint: 'Wähle den passenden Auslöser-Typ.',
                                actionValueTypeHint: 'Lege den richtigen Typ des Aktionswerts fest. Zum Beispiel ist der Wert "On" ein String.',
                                actionValueHint: 'Prüfe in deinem gewünschten Aktions-Skript, welche Werte zulässig sind.',
                                triggerLogicHint: 'Erweiterte Trigger-Logik für den Auslöser im JSON-Format.',
                                descriptionHint: 'Beschreibe den Auslöser näher'
                            }
                        },
                        queue: {
                            noEntriesFound: 'Kein Warteschlangeneintrag gefunden',
                            title: 'Aktionswarteschlange',
                            createdAt: 'Eingestellt am',
                            startedAt: 'Begonnen am',
                            endedAt: 'Beendet am',
                        }
                    },
                    hardware: {
                        title: 'Hardware',
                        notFound: 'Keine Hardware gefunden',
                        name: 'Name',
                        add: 'Hardware hinzufügen',
                        edit: 'Hardware bearbeiten',
                        canNotDeleteHint: 'Hardware kann nicht gelöscht werden da sie von einer Steuerbaren Aktion verwendet wird',
                        confirmDeletion: 'Wollen Sie die Hardware wirklich löschen?',
                    },
                    button: {
                        loginToManage: 'Anmelden, um Organisation zu verwalten',
                        create: 'Erstellen',
                        add: 'Hinzufügen',
                        update: 'Änderungen speichern,'
                    },
                    label: {
                        organizationName: 'Organisationsname',
                        setPublic: 'Öffentlich einstellen',
                        setCameraCarousel: 'Bilder oder Livestream'
                    },
                    placeholder: {
                        enterOrganizationName: 'Geben Sie den Organisationsnamen ein'
                    },
                    error: {
                        organizationNameTaken: 'Organisationsname bereits vergeben',
                        fireFoxError: 'Ihr Browser wird nicht vollständig unterstützt. Einige Funktionen wie Grafiken und Kameras funktionieren möglicherweise nicht wie erwartet.\nBitte verwenden Sie einen anderen Browser für das beste Erlebnis.'
                    },
                    userprofile: {
                        changPassword: 'Passwort ändern',
                        notifications: {
                            success: {
                                title: 'Erfolgreich aktualisiert',
                                message: 'Profilname erfolgreich aktualisiert!',
                            },
                            error: {
                                title: 'Profilname konnte nicht aktualisiert werden',
                            }
                        },
                        enterName: 'Geben Sie Ihren Anzeigenamen ein',
                        saveChanges: 'Änderungen speichern',
                        changePassword: 'Passwort ändern',
                    },
                    camera: {
                        active: 'Aktiv',
                        inactive: 'Inaktiv',
                        cameras: 'Kameras',
                        hint: {
                            nameHint: 'Name der Kamera',
                            locationHint: 'Standort der Kamera',
                            modelNrHint: 'Modellnummer der Kamera',
                            intervalSecondsHint: 'Intervall zum Aufnehmen von Bildern',
                            resolutionHint: 'Auflösung der Kamera',
                            livestreamUrlHint: 'URL für den Livestream',
                            snapshotUrlHint: 'URL für den Schnappschuss',
                        },
                        cameraList: 'Kamera-Liste',
                        noCamerasFound: 'Keine Kamera gefunden',
                        location: 'Standort',
                        enterLocation: 'Standort eingeben',
                        modelNr: 'Modell Nr.',
                        enterModelNr: 'Modell Nr. eingeben',
                        intervalSeconds: 'Intervall in Sekunden',
                        enterIntervalSeconds: 'Intervall in Sekunden eingeben',
                        resolution: 'Auflösung',
                        enterResolution: 'Auflösung eingeben',
                        livestreamUrl: 'Livestream-URL',
                        enterLivestreamUrl: 'Livestream-URL eingeben',
                        snapshotUrl: 'Snapshot-URL',
                        enterSnapshotUrl: 'Snapshot-URL eingeben',
                        addCamera: 'Kamera hinzufügen',
                        editCamera: 'Kamera bearbeiten',
                        createCamera: 'Kamera erstellen',
                        updating: 'Kamera wird geändert',
                    },
                    harvestEntityForm: {
                        hint: {
                            dateDescription: 'Datum der Ernte',
                            amountDescription: 'Menge der Ernte',
                            notesDescription: 'Notizen zur Ernte',
                        },
                        addHarvest: 'Ernte hinzufügen',
                        editHarvest: 'Ernte bearbeiten',
                        dateLabel: 'Datum',
                        datePlaceholder: 'Datum auswählen',
                        amountLabel: 'Menge (kg)',
                        amountPlaceholder: 'Menge eingeben',
                        amountDescription: "Verwenden Sie '.' für Dezimalstellen, nicht ','",
                        notesLabel: 'Notizen',
                        notesPlaceholder: 'Notizen eingeben',
                        saveButton: 'Speichern',
                        details: 'Ernte Details',
                        deleteTitle: 'Wollen Sie diese Ernte wirklich löschen?',
                    },
                    timeRangeSelector: {
                        from: 'Von',
                        datePlaceholder: "Datum auswählen",
                        to: 'Zu',
                        apply: 'Anwenden',
                        label24H: 'Letzten 24H',
                        labelWeek: 'Letzte Woche',
                        labelMonth: 'Letzten Monat',
                        labelYear: 'Letztes Jahr',
                        labelCustom: 'Benutzerdefiniertes Datum'
                    },
                    weatherForecast: {
                        title: 'Wettervorhersage',
                        location: 'Standort',
                        forecastDate: 'Vorhersagedatum',
                        fetchDate: 'Abrufdatum',
                        temperatureMinC: 'Mindesttemperatur',
                        temperatureMaxC: 'Höchsttemperatur',
                        rainMM: 'davon Regen',
                        sunshineDurationSeconds: 'Sonnenscheindauer',
                        windSpeedMax: 'Maximale Windgeschwindigkeit',
                        sunrise: 'Sonnenaufgang',
                        sunset: 'Sonnenuntergang',
                        precipitationMM: 'Niederschlag',
                        precipitationProbability: 'Niederschlagswahrscheinlichkeit',
                        text: {
                            temperature: 'Temperatur',
                            precipitation: 'Niederschlag',
                            probability: 'Wahrscheinlichkeit für',
                            today: 'Heute',
                            tomorrow: 'Morgen',
                            afterTomorrow: 'Übermorgen',
                        },
                        weatherCode: {
                            weatherCode: 'Wettercode',
                            tooltip: 'Zeigt das schlimmstmögliche Wetter, das für den Tag erwartet wird.',
                            clear: 'Klar',
                            mainlyClear: 'Überwiegend klar',
                            partlyCloudy: 'Teilweise bewölkt',
                            overcast: 'Bedeckt',
                            fog: 'Nebel',
                            fogWithRime: 'Nebel mit Raureif',
                            drizzleLight: 'Leichter Nieselregen',
                            drizzleModerate: 'Mäßiger Nieselregen',
                            drizzleDense: 'Dichter Nieselregen',
                            freezingDrizzleLight: 'Leichter gefrierender Nieselregen',
                            freezingDrizzleDense: 'Dichter gefrierender Nieselregen',
                            rainLight: 'Leichter Regen',
                            rainModerate: 'Mäßiger Regen',
                            rainHeavy: 'Starker Regen',
                            freezingRainLight: 'Leichter gefrierender Regen',
                            freezingRainHeavy: 'Starker gefrierender Regen',
                            snowFallLight: 'Leichter Schneefall',
                            snowFallModerate: 'Mäßiger Schneefall',
                            snowFallHeavy: 'Starker Schneefall',
                            snowGrains: 'Schneekörner',
                            rainShowersLight: 'Leichte Regenschauer',
                            rainShowersModerate: 'Mäßige Regenschauer',
                            rainShowersHeavy: 'Starke Regenschauer',
                            snowShowersLight: 'Leichte Schneeschauer',
                            snowShowersHeavy: 'Starke Schneeschauer',
                            thunderstormWithLightHail: 'Gewitter mit leichtem Hagel',
                            thunderstormWithModerateHail: 'Gewitter mit moderatem Hagel',
                            thunderstormWithHail: 'Gewitter mit Hagel',
                            thunderstormWithHeavyHail: 'Gewitter mit starkem Hagel',
                        },
                    },
                    location: {
                        noLocation: 'Kein Standort',
                        name: 'Name',
                        city: 'Stadt',
                        street: 'Straße',
                        houseNumber: 'Hausnummer',
                        latitude: 'Breitengrad',
                        longitude: 'Längengrad',
                        gatherForecasts: 'Wettervorhersage',
                        gatherForecastsActive: 'Vorhersagen werden gesammelt',
                        gatherForecastsNotActive: 'Keine Vorhersagen',
                        buttons: {
                            showForm: 'Neuen Standort erstellen',
                            hideForm: 'Ausblenden',
                            addLocation: 'Standort hinzufügen',
                            editLocation: 'Standort bearbeiten',
                            createLocation: 'Standort erstellen',
                        },
                        text: {
                            location: 'Standort',
                            locations: 'Standorte',
                            addLocation: 'Standort hinzufügen',
                            isActive: 'Vorhersagen abrufen',
                            isNotActive: 'Keine Vorhersagen',

                        },
                        notifications: {
                            loading: {
                                title: 'Laden',
                                message: 'Lade Standorte...',
                            },
                            success: {
                                title: 'Erfolgreich aktualisiert',
                                message: 'Standort erfolgreich aktualisiert!',
                            },
                            error: {
                                title: 'Standort konnte nicht aktualisiert werden',
                                message: 'Standort konnte nicht gesendet werden',
                            },
                        },
                    },
                    notification: {
                        title: 'Matrix Benachrichtigungsräume',
                        confirmDeletion: 'Löschung bestätigen',
                        add: 'Benachrichtigungsraum hinzufügen',
                        roomId: 'Raum-ID',
                        name: 'Name',
                        notFound: 'Keine Benachrichtigungsräume gefunden.',
                        roomIdPlaceholder: 'Matrix-Raum-ID eingeben (z.B. !...:matrix.org)',
                        namePlaceholder: 'Anzeigenamen eingeben',
                    },
                    overview: {
                        green: 'Alles gut',
                        yellow: 'Ein Wert verspätet',
                        red: 'Mehrere Werte fehlen',
                        grey: 'Inaktiv',
                        other: 'Unbekannt',
                        lastPing: 'Letzter Ping',
                        pingResult: 'Ping Ergebnis',
                    },
                    admin: {
                        resetPassword: 'Passwort zurücksetzten',
                        copyPasswordHint: 'Kopieren Sie das neue Passwort uns übersenden Sie es dem Nutzer',
                        copy: 'Kopieren',
                        copied: 'Kopiert',
                        activeUsers: 'Aktive Nutzer',
                        inactiveUsers: 'Inaktive Nutzer',
                        deactivate: 'Deaktivieren',
                        reactivate: 'Reaktivieren',
                    },
                    energy: {
                        dashboardTitle: 'Energiemanagement',
                        batteryLevel: 'Batteriestand',
                        powerBalance: 'Leistungsbilanz',
                        production: 'Erzeugung',
                        consumption: 'Verbrauch',
                        netPower: 'Nettoleistung',
                        gridStatus: 'Netzstatus',
                        gridConnected: 'Verbunden',
                        gridDisconnected: 'Getrennt',
                        gridConnectAt: 'Verbinden bei',
                        currentAction: 'Aktuelle Aktion',
                        sources: 'Energiequellen',
                        consumers: 'Energieverbraucher',
                        noSourcesFound: 'Keine Energiequellen gefunden',
                        noConsumersFound: 'Keine Energieverbraucher gefunden',
                        addSource: 'Energiequelle hinzufügen',
                        editSource: 'Energiequelle bearbeiten',
                        addConsumer: 'Energieverbraucher hinzufügen',
                        editConsumer: 'Energieverbraucher bearbeiten',
                        sourceName: 'Name',
                        sourceNamePlaceholder: 'Quellennamen eingeben',
                        sourceType: 'Quellentyp',
                        sourceSolar: 'Solar',
                        sourceWind: 'Wind',
                        sourceGrid: 'Stromnetz',
                        sourceBattery: 'Batterie',
                        sourceGenerator: 'Generator',
                        maxOutputWatts: 'Max. Ausgang (W)',
                        currentOutputWatts: 'Aktueller Ausgang (W)',
                        currentOutput: 'Aktueller Ausgang',
                        maxOutput: 'Max. Ausgang',
                        weatherDependent: 'Wetterabhängig',
                        weatherDependentDescription: 'Ausgangsleistung hängt von Wetterbedingungen ab',
                        consumerName: 'Name',
                        consumerNamePlaceholder: 'Verbrauchernamen eingeben',
                        consumptionWatts: 'Verbrauch (W)',
                        priority: 'Priorität',
                        priorityDescription: '1 = Kritisch, 10 = Optional',
                        priorityCritical: 'Kritisch',
                        priorityMedium: 'Mittel',
                        priorityLow: 'Niedrig',
                        consumerShutdownThreshold: 'Auto-Abschalt-Schwellwert',
                        consumerShutdownThresholdDescription: 'Batteriestand, bei dem dieser Verbraucher automatisch abgeschaltet wird',
                        shutdownNever: 'Nie',
                        aiShutdown: 'KI Abschaltung',
                        aiControlled: 'KI Gesteuert',
                        shutdownUseGlobal: 'Verwendet globale Schwellwert-Einstellungen (keine individuelle Abschaltung)',
                        shutdownAtPercent: 'Wird abgeschaltet wenn Batterie unter {{percent}}% fällt',
                        dependencies: 'Abhängigkeiten',
                        dependenciesDescription: 'Verbraucher, die für diesen Verbraucher aktiv sein müssen',
                        selectDependencies: 'Abhängigkeiten auswählen',
                        noDependencies: 'Keine',
                        isActive: 'Aktiv',
                        nameRequired: 'Name ist erforderlich',
                        consumerCreated: 'Verbraucher erfolgreich erstellt',
                        consumerUpdated: 'Verbraucher erfolgreich aktualisiert',
                        consumerDeleted: 'Verbraucher erfolgreich gelöscht',
                        sourceCreated: 'Quelle erfolgreich erstellt',
                        sourceUpdated: 'Quelle erfolgreich aktualisiert',
                        sourceDeleted: 'Quelle erfolgreich gelöscht',
                        settings: 'Energieeinstellungen',
                        manualBatteryLevel: 'Batteriestand (Wh)',
                        manualBatteryLevelDescription: 'Setze den aktuellen Batteriestand manuell zum Testen',
                        updateBatteryLevel: 'Batteriestand aktualisieren',
                        thresholdConfiguration: 'Schwellwert-Konfiguration',
                        gridConnectThreshold: 'Netzverbindungs-Schwellwert',
                        gridConnectThresholdDescription: 'Verbindung zum Netz herstellen, wenn Batterie unter diesen Wert fällt',
                        shutdownThreshold: 'Abschalt-Schwellwert',
                        shutdownThresholdDescription: 'Nicht-kritische Verbraucher unter diesem Wert abschalten',
                        warningThreshold: 'Warn-Schwellwert',
                        warningThresholdDescription: 'Warnstatus unter diesem Wert anzeigen',
                        gridDisconnectThreshold: 'Netztrennungs-Schwellwert',
                        gridDisconnectThresholdDescription: 'Netz trennen, wenn Batterie diesen Wert überschreitet',
                        thresholdNote: 'Schwellwerte werden im Backend konfiguriert',
                        configurationTitle: 'Energie-Konfiguration',
                        configurationSubtitle: 'Schwellwerte und Batterieeinstellungen für dieses FPF konfigurieren',
                        unsavedChanges: 'Ungespeicherte Änderungen',
                        batteryCapacity: 'Batteriekapazität',
                        maxBatteryCapacity: 'Maximale Batteriekapazität',
                        maxBatteryCapacityDescription: 'Gesamte Batteriespeicherkapazität in Wattstunden',
                        thresholdSettings: 'Schwellwert-Einstellungen',
                        thresholdPreview: 'Batterie-Zonen Vorschau',
                        zoneShutdown: 'Abschaltung',
                        zoneGridConnect: 'Netzverbindung',
                        zoneWarning: 'Warnung',
                        zoneNormal: 'Normal',
                        zoneOptimal: 'Optimal',
                        resetChanges: 'Zurücksetzen',
                        saveConfiguration: 'Konfiguration speichern',
                        configSaved: 'Energiekonfiguration erfolgreich gespeichert',
                        linkedSensor: 'Verknüpfter Sensor',
                        linkedSensorDescription: 'Verknüpfung mit einem Sensor für Live-Verbrauchsmessung (z.B. Smart-Plug Leistungsmessung)',
                        linkedSensorSourceDescription: 'Verknüpfung mit einem Sensor für Live-Erzeugungsmessung (z.B. Solar-Wechselrichter)',
                        selectSensor: 'Sensor auswählen...',
                        sensorLinkedInfo: 'Live-Verbrauchsdaten werden von diesem Sensor verwendet anstelle des statischen Wertes.',
                        sensorLinkedSourceInfo: 'Live-Erzeugungsdaten werden von diesem Sensor verwendet anstelle des statischen Wertes.',
                        linkedAction: 'Verknüpfte Steuerungsaktion',
                        linkedActionDescription: 'Verknüpfung mit einer Steuerungsaktion für automatische Ein-/Ausschaltung (z.B. Smart-Plug)',
                        linkedActionSourceDescription: 'Verknüpfung mit einer Steuerungsaktion für Quellensteuerung (z.B. Netzschalter)',
                        selectAction: 'Aktion auswählen...',
                        actionLinkedInfo: 'Dieser Verbraucher kann automatisch vom Energiemanagement-System gesteuert werden.',
                        actionLinkedSourceInfo: 'Diese Quelle kann automatisch vom Energiemanagement-System gesteuert werden.',
                        consumptionLiveNote: 'Falls ein Sensor verknüpft ist, wird dieser Wert nur als Fallback verwendet.',
                        outputLiveNote: 'Falls ein Sensor verknüpft ist, wird dieser Wert nur als Fallback verwendet.',
                        action: {
                            normal: 'Normalbetrieb',
                            connect_grid: 'Netz verbinden',
                            disconnect_grid: 'Netz trennen',
                            shutdown_non_critical: 'Nicht-Kritische abschalten',
                            emergency_shutdown: 'Notabschaltung'
                        }
                    },
                    resources: {
                        managementTitle: 'Ressourcenverwaltung',
                        managementDesc: 'Ressourcenüberwachung und -verwaltung konfigurieren',
                        waterResourceTitle: 'Wasserressourcen-Management',
                        waterResourceDesc: 'Funktionen zur Wasser- und Bodenüberwachung aktivieren',
                        waterSensorId: 'Wassersensor-ID',
                        waterSensorIdPlaceholder: 'z.B. wasser-sensor-01',
                        soilSensorId: 'Bodensensor-ID',
                        soilSensorIdPlaceholder: 'z.B. boden-feuchte-01',
                        tankCapacity: 'Tankkapazität'
                    },
                    water: {
                        dashboardTitle: 'Wassermanagement',
                        tankLevel: 'Wassertankstand',
                        currentLevel: 'Aktueller Stand',
                        systemStatus: 'Systemstatus',
                        dailyUsage: 'Durchschnittlicher Verbrauch',
                        pumpStatus: 'Pumpenstatus',
                        modelsTitle: 'Wasserverbrauchsvorhersage',
                        waterLevelChartTitle: 'Wasserstand (Letzte 7 Tage)',
                        fieldMoisture: 'Bodenfeuchtigkeitswerte',
                        status: 'Status',
                        moisture: 'Feuchtigkeit',
                        field: 'Feld',
                        dry: 'Trocken',
                        moderate: 'Mittel',
                        moist: 'Feucht',
                        wet: 'Nass',
                        aiInsight: 'KI-Einblick',
                        rainProbability: 'Regenwahrscheinlichkeit heute beträgt',
                        statusCritical: 'Kritisch',
                        statusNormal: 'Normal',
                        statusLow: 'Wasserstand niedrig',
                        statusGood: 'Alles in Ordnung',
                        pumpActive: 'Diese Woche aktiv',
                        pumpInactive: 'Diese Woche inaktiv',
                        frozen: 'GEFROREN',
                        noData: 'Keine Daten verfügbar',
                    }
                },
            },
        },
        lng: navigator.language.split('-')[0],
        fallbackLng: 'en',
        interpolation: {
            escapeValue: false,
        },
    });

export default i18n;